export default __webpack_public_path__ + "static/media/SkirtBrimRaftImg.93aedd80.jpg";